import { Component, Prop, Emit, Watch, Vue } from "vue-property-decorator";
import { Action, Getter, State, Mutation } from "vuex-class";
import moment from "moment";

@Component({})
export default class MultiSelectDays extends Vue {

  // Valores posibles
  @Prop({ default: () => [] }) values;

  // Mensaje en caso de no haber seleccionado una opción
  @Prop({ default: '' }) placeholder;

  @Getter getCity;
  @Getter getCurrentProgram;
  @Getter getCurrentAddress;
  @Getter getCurrentCityZone;

  // Mutations
  @Mutation CURRENT_PROGRAM;
  @Mutation CURRENT_CITY_ZONE;

  openSelector = false;
  currentOption = null;
  availableDays = [];
  currentProgram = {
    day: null,
    hourRange: ""
  };

  get getPlaceHolder() {
    let response = "Selecciona una opción";
    if(this.placeholder) {
      response = this.placeholder;
    }
    return response;
  }

  mounted() {
    console.log('City Zone',this.getCurrentAddress)
    this.setAvailableWeekDays();
  }

  setAvailableWeekDays() {
    let daysAvailables = [1, 2, 3, 4, 5, 6];
    const deliverySchedule = this.getCurrentCityZone.delivery_schedule;
    if (this.getCurrentCityZone && deliverySchedule) {
      const tempWeekdays = deliverySchedule.weekdays ? deliverySchedule.weekdays : [];
      if(tempWeekdays.length) {
        tempWeekdays.forEach((item) => {
          daysAvailables.push(parseInt(item));
        });
        daysAvailables = [...tempWeekdays];
      }
    }
    let startDay = moment(new Date());
    let nextDay = startDay.clone();
    if(this.getTime() < 15) {
      nextDay.add(1, "days");
    }
    else {
      nextDay.add(2, "days");
    }
    
    let endDay = startDay.clone();
    if(this.getTime() < 15) {
      endDay.add(5, "days");
    }
    else {
      endDay.add(6, "days");
    }
    
    let dayOfWeek = -1;
    while (nextDay.isSameOrBefore(endDay)) {
      dayOfWeek = nextDay.day();
      let found = false;
      for(let i = 0; i < daysAvailables.length && !found; i++) {
        if(dayOfWeek == daysAvailables[i]) {
          found = true;
        }
      }
      if (found) {
        const nextDayClone = nextDay.clone();
        nextDayClone.set('hour', 0);
        nextDayClone.set('minute', 0);
        nextDayClone.set('second', 0);
        this.availableDays.push(nextDayClone);
      } else {
        endDay.add(1, "days");
      }
      nextDay.add(1, "days");
    }
  }

  getTime() {
    let actualDate = new Date();
    let hours = actualDate.getHours();
    return hours
  }

  pickDay(day) {
    
    if(day) {
      day.set('hour', 0);
      day.set('minute', 0);
      day.set('second', 0);
      this.currentProgram.day = day;
    }
    this.openSelector = false;
    this.$emit('onSelect', this.currentProgram.day);
  }

  get getSelectedDay() {
    let response = "Seleccione una opción";
    if(this.currentProgram.day) {
      response = this.currentProgram.day.format('dddd DD MMMM');
    }
    return response;
  }

}
